import React from 'react';
import {
  errorMessagesIndex,
  IHumanReadableError,
} from '../../../utils/errorMapping/errorTranslationsIndex';
import { Trans } from '@lingui/react';

const FormattedError = ({ type }: { type: IHumanReadableError['type'] }) => {
  const errorMessage = errorMessagesIndex[type];
  return (
    <div style={{ height: 'fit-content' }}>
      {errorMessage || (
        <Trans id=" An error occurred while attempting request. " />
      )}
    </div>
  );
};

export default FormattedError;
